var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLicenseShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6547",
    "data-name": "Group 6547",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6546",
    "data-name": "Group 6546"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 1.12,
    cy: 1.12,
    r: 1.12,
    transform: "translate(15.88 14.38)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M17,17.5c-.73,0-2.19.36-2.24,1.08a2.729,2.729,0,0,0,4.48,0C19.19,17.86,17.73,17.5,17,17.5Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M18,11.09V6.27L10.5,3,3,6.27v4.91A10.213,10.213,0,0,0,10.5,21a9.166,9.166,0,0,0,1.6-.55A6,6,0,1,0,18,11.09ZM11,17a5.766,5.766,0,0,0,.23,1.62,6.587,6.587,0,0,1-.73.3A8.208,8.208,0,0,1,5,11.18V7.58l5.5-2.4L16,7.58v3.51A6,6,0,0,0,11,17Zm6,4a4,4,0,1,1,4-4A4,4,0,0,1,17,21Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLicenseShield);
export default __webpack_public_path__ + "static/media/user-license-shield.205e0cee8836d6c9171f963dbeea86da.svg";
export { ForwardRef as ReactComponent };